import { render, staticRenderFns } from "./FormatAlignLeftIcon.vue?vue&type=template&id=d19babd6"
import script from "./FormatAlignLeftIcon.vue?vue&type=script&lang=js"
export * from "./FormatAlignLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports